import { render, staticRenderFns } from "./NewMessageAbsenceInfo.vue?vue&type=template&id=5b551e3c&scoped=true"
import script from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
export * from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
import style0 from "./NewMessageAbsenceInfo.vue?vue&type=style&index=0&id=5b551e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b551e3c",
  null
  
)

export default component.exports